import React from "react"
import SbEditable from "storyblok-react"
import Markdown from "react-markdown"
import { useStaticQuery, graphql } from "gatsby"
import { getFluidGatsbyImage } from "gatsby-storyblok-image"

import { BigBlogTeaser, transformLinkUri } from "gatsby-theme-gba"

const BigBlogTeasersEditable = ({ blok }) => {
  const date = blok.date
    ? new Date(blok.date).toLocaleDateString("de-DE")
    : blok.date

  const fluidProps = getFluidGatsbyImage(blok.image, {
    width: 791,
  })

  const { file, allFile } = useStaticQuery(graphql`
    query BigBlogTeaserExampleQuery {
      file(relativePath: { eq: "big-blog-teaser.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      allFile(
        filter: { id: { regex: "/(?:(?:.*)bigPageTeaser)|(?:(?:blog))/" } }
      ) {
        edges {
          node {
            id
            name
            childImageSharp {
              fluid(maxWidth: 791, quality: 80) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
      }
    }
  `)

  let filteredFiles = allFile.edges.filter(function(projectFile) {
    if (!projectFile.node.id.includes(blok.image.substring(1))) {
      return false // skip
    }

    return true
  })

  let imageFile = filteredFiles[0]
    ? filteredFiles[0].node.childImageSharp.fluid
    : fluidProps

  return (
    <SbEditable content={blok}>
      <BigBlogTeaser
        date={date}
        image={imageFile || file.childImageSharp.fluid}
        imageAlt={blok.imgAlt}
        blogHeading={blok.headline || "Headline"}
        blogLink={blok.link}
        blogLinkText={blok.linkText}
        linkTarget={blok.linkTarget}
        mode={blok.mode}
        currentLanguage={blok.currentLanguage}
        seoLinks={blok.seoLinks}
        tagList={blok.tagList}
      >
        <Markdown
          source={blok.previewText}
          transformLinkUri={uri => {
            return transformLinkUri(
              uri,
              "",
              blok.currentLanguage,
              blok.seoLinks
            )
          }}
        />
      </BigBlogTeaser>
    </SbEditable>
  )
}

export default BigBlogTeasersEditable
